import { BaseClient } from 'src/common-services/clients/base-client'

export class SystemClient extends BaseClient {
  flush(): Promise<void> {
    return this.call('/flush', 'POST')
  }
}
